import {lazy} from 'react';

export const PaymentFileValidationLazy = lazy(() => import(/* webpackChunkName: "paymentFileValidation" */ '.'));
